<template>
	<button :type="type ?? ButtonType.Button" :class="styles">
		<slot/>
	</button>
</template>
<script setup lang="ts">
import {ButtonType} from '@/Types/Enums/ButtonType'
import {ButtonSize} from '@/Types/Enums/ButtonSize'
import {computed, type ComputedRef, defineProps} from 'vue'

const props = defineProps<{
	colors:string,
	size?:ButtonSize,
	type?:ButtonType,
	grouped?:boolean,
}>()

const styles:ComputedRef<string|undefined> = computed(() => {
	const base = `whitespace-nowrap text-sm ${props.grouped ? 'border-none first:rounded-l last:rounded-r' : 'border rounded'} ${props.colors}`
	switch(props.size){
		case ButtonSize.Small:
			return `${base} px-1`
		case ButtonSize.Large:
			return `${base} px-3 py-2`
		case ButtonSize.Huge:
			return `${base} px-4 py-3`
		default:
			return `${base} px-2 py-1`
	}
})
</script>
